import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { removeFromCart } from "../../redux/actions";
import ShoppingCartOrder from "./ShoppingCartOrder";
import "../../css/ShoppingCart.css";

const ShoppingCartModal = ({ onClose, menuId, restaurantId }) => {
  const cartItems = useSelector((state) => state.cart.cartItems);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const totalAmount = cartItems
    .reduce(
      (sum, item) =>
        sum +
        (typeof item.price === "number" ? item.price : 0) *
          (item.quantity || 0),
      0
    )
    .toFixed(2);

  const handleCheckoutClick = () => {
    if (cartItems.length === 0 || totalAmount <= 0) {
      alert("Your cart is empty. Please add items before checking out.");
      return;
    }

    onClose();
    navigate(`/menu/${menuId}/${restaurantId}/checkout`);
  };

  return (
    <div className="cart-modal-backdrop">
      <div className="cart-modal">
        <h3 className="cart-modal-title">Your Cart</h3>
        <div className="cart-items-scroll">
          {cartItems.length === 0 ? (
            <p className="cart-empty">Your cart is empty.</p>
          ) : (
            cartItems.map((item) => (
              <ShoppingCartOrder
                key={item.id}
                item={item}
                onRemove={() => dispatch(removeFromCart(item.id))}
              />
            ))
          )}
        </div>
        <div className="cart-total">
          <span>Total:</span>
          <span>${totalAmount}</span>
        </div>
        <div className="cart-actions">
          <button className="cart-close-button" onClick={onClose}>
            Close
          </button>
          <button
            className="cart-checkout-button"
            onClick={handleCheckoutClick}
          >
            Checkout
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShoppingCartModal;
